import { render, staticRenderFns } from "./Alerts.vue?vue&type=template&id=6ba24602&"
import script from "./Alerts.js?vue&type=script&lang=js&"
export * from "./Alerts.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports